import React, { useRef, useState } from 'react';
import { connectField, filterDOMProps, HTMLFieldProps } from 'uniforms';
import PinIcon from '../../../../../public/svg/pin.svg';
import DirectusImage from '@/components/image/DirectusImage';

export type ImageFieldProps = HTMLFieldProps<string, HTMLDivElement> & { fileExtension?: string };

function FileField({ onChange, label, name, id, fileExtension = '', ...props }: ImageFieldProps) {
  const fileInputRef = useRef(null);
  const [fileName, setFileName] = useState(`Ajoutez un fichier ( ${label} )`);

  const handleFileChange = (fileList: FileList) => {
    const fileName = fileList[0].name;
    // @ts-ignore
    onChange(fileList[0]);
    setFileName(fileName);
  };

  const triggerFileInput = () => {
    if (fileInputRef.current) {
      // @ts-ignore
      fileInputRef.current.click();
    }
  };

  return (
    <div {...filterDOMProps(props)} className="flex items-center gap-4 py-2">
      {/* {label && (
        <label htmlFor={id} className="min-w-[200px]">
          {label}
        </label>
      )} */}

      <input
        accept={generateFileAccepts(fileExtension)}
        ref={fileInputRef}
        id={id}
        name={name}
        onChange={({ target: { files } }) => {
          if (files && files[0]) {
            // @ts-ignore
            handleFileChange(files);
          }
        }}
        className="hidden"
        type="file"
      />
      <button
        type="button"
        className="btn flex w-full justify-start rounded border border-gray-400 bg-white text-sm font-normal text-gray-400 hover:bg-white focus:outline-none"
        onClick={triggerFileInput}
      >
        <div className="flex items-center justify-start gap-2">
          <DirectusImage
            src={PinIcon}
            dimension={{ width: 14, height: 14 }}
            alt="Icon telechargez un fichier"
          />
          {fileName}
        </div>
      </button>
    </div>
  );
}

const generateFileAccept = (fileExtension: string) => {
  switch (fileExtension) {
    case 'pdf':
      return 'application/pdf';
    case 'jpg':
    case 'jpeg':
      return 'image/jpeg';
    case 'png':
      return 'image/png';
    default:
      return 'application/pdf';
  }
};

const generateFileAccepts = (fileExtension: string) => {
  if (!fileExtension) {
    return 'application/pdf';
  }
  return fileExtension
    .split('\n')
    .map((ext) => {
      return generateFileAccept(ext);
    })
    .join(', ');
};

export default connectField<ImageFieldProps>(FileField);
